<template>
  <div class="valu-banner rounded-lg relative overflow-hidden xl:h-full xl:min-h-[255px]" :class="{ 'rtl-slide': $i18n.locale !== 'en' }">
    <transition name="slide">
      <div v-if="activeBanner" :key="activeSlideIndex" class="h-full w-full">
        <template v-if="activeBanner.type === 'credit'">
          <div class="bg-[#e4f0fa] h-full w-full flex flex-col items-center justify-center text-center px-4">
            <div class="xl:text-5xl text-4xl xl:mb-3 sm:mb-2 mb-1" aria-hidden="true">{{ activeBanner.icon }}</div>
            <p class="text-darkblue xl:text-2xl sm:text-xl text-lg font-semibold leading-tight sm:mb-2 mb-0">{{ $t('Up to {creditLimit} EGP, Just for You', { creditLimit: Number(this.creditLimit).toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }) }}</p>
            <p class="text-darkblue xl:text-3xl sm:text-2xl text-xl font-bold leading-tight xl:mb-5 sm:mb-3 mb-2">{{ $t('Your Loan Is Ready.') }}</p>
            <div class="cursor-pointer vs-con-loading__container" id="get-started-btn-loading">
              <shipblu-button size="small" color="primary" @click="getStarted()" :textButton="$t('I’m Interested')" :iconStyle="{iconPosition:'right', RightIconName: $i18n.locale === 'en' ? 'ArrowRightIcon' : 'ArrowLeftIcon', RightIconLibrary: 'feather'}"/>
            </div>
          </div>
        </template>
        <template v-else>
          <img :src="activeBanner.desktop" :alt="activeBanner.alt" :class="desktopImageClass">
          <img :src="activeBanner.tablet" :alt="activeBanner.alt" class="lg:hidden md:block hidden w-full h-full">
          <img :src="activeBanner.mobile" :alt="activeBanner.alt" class="md:hidden block w-full h-full">
        </template>
      </div>
    </transition>

    <div v-if="bannerSlides.length > 1" class="absolute bottom-3 left-0 right-0 z-10 flex justify-center items-center">
      <button v-for="(slide, index) in bannerSlides" :key="index" type="button" class="mx-1 h-2 p-0 border-0 rounded-full bg-white cursor-pointer" :class="index === activeSlideIndex ? 'w-5 opacity-100' : 'w-2 opacity-75'" @click="goToSlide(index)"></button>
    </div>
  </div>
</template>

<script>
import { sendRequest }  from '../../../http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData.js'
import common  from '@/assets/utils/common'

export default {
  name: 'ValuBanner',
  data () {
    return {
      activeSlideIndex: 0,
      slideInterval: null,
      bannerSlides: [
        {
          type: 'image',
          alt: 'upper-egypt-slide-1',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        },
        {
          type: 'image',
          alt: 'upper-egypt-slide-2',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        },
        {
          type: 'image',
          alt: 'upper-egypt-slide-3',
          desktop: require('@/assets/images/pages/upper-egypt.webp'),
          tablet: require('@/assets/images/pages/upper-egypt-md.jpeg'),
          mobile: require('@/assets/images/pages/upper-egypt-sm.jpeg')
        }
        // {
        //   type: 'credit',
        //   alt: 'credit-limit-slide',
        //   icon: '💸'
        // }
      ],
      creditLimit: 0
    }
  },
  computed: {
    activeBanner () {
      return this.bannerSlides[this.activeSlideIndex]
    },
    desktopImageClass () {
      return `lg:block hidden xl:absolute h-full xl:w-auto w-full ${this.$i18n.locale === 'en' ? 'left-0' : 'right-0'}`
    }
  },
  mounted () {
    this.setAutoSlide()
    this.getAnonymousCreditLimit()
  },
  beforeDestroy () {
    clearInterval(this.slideInterval)
  },
  methods: {
    setAutoSlide () {
      clearInterval(this.slideInterval)
      this.slideInterval = setInterval(this.showNextSlide, 6000)
    },
    showNextSlide () {
      this.activeSlideIndex = (this.activeSlideIndex + 1) % this.bannerSlides.length
    },
    goToSlide (index) {
      this.activeSlideIndex = index
      this.setAutoSlide()
    },
    getAnonymousCreditLimit () {
      sendRequest(true, false, this, 'api/v1/billing/flend/anonymous-credit-limit/', 'get', null, true,
        (response) => {
          this.creditLimit = response?.data?.anonymousCreditLimit
        }
      )
    },
    getStarted () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#get-started-btn-loading',
        scale: 0.45
      })
      sendRequest(true, false, this, 'api/v1/billing/flend/financing-application/', 'post', {}, true,
        () => {
          this.$vs.notify({
            color:'success',
            title: i18nData[this.$i18n.locale]['Success'],
            text: i18nData[this.$i18n.locale]['Thank you for your interest, we have received your request and a team member will be contacting you within 1 business day.'],
            position: 'top-center'
          })
          this.$vs.loading.close('#get-started-btn-loading > .con-vs-loading')
        }, (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#get-started-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>

<style scoped>
.valu-banner {
  aspect-ratio: 1600 / 763;
}

@media (min-width: 768px) {
  .valu-banner {
    aspect-ratio: 740 / 270;
  }
}

@media (min-width: 992px) {
  .valu-banner {
    aspect-ratio: 1060 / 260;
  }
}

@media (min-width: 1200px) {
  .valu-banner {
    aspect-ratio: auto;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.45s ease;
}

.slide-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}

.rtl-slide .slide-enter {
  transform: translateX(-100%);
}

.rtl-slide .slide-leave-to {
  transform: translateX(100%);
}
</style>
